import { render } from "./ZusatzobjekteDetails.vue?vue&type=template&id=3fcd2d33"
import script from "./ZusatzobjekteDetails.vue?vue&type=script&lang=js"
export * from "./ZusatzobjekteDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__